<template>
    <div class="aba-cliente select-modal">
        <container-loader v-if="isLoading && !$store.getters.isLoading" />
        <div class="vertical-flow">
            <div class="columns">
                <div
                    class="column"
                    :class="[permissaoVincular ? 'is-6' : 'is-8']"
                >
                    <search-bar
                        :onSearch="debouncedOnSearch"
                        tooltipLabel="msg-campo-busca-desconto-qtde"
                    />
                </div>

                <div
                    class="column"
                    :class="[permissaoVincular ? 'is-3' : 'is-4']"
                >
                    <vss-select
                        ref="situacaoSelect"
                        :searchable="false"
                        :options="situacaoSelect"
                        v-model="situacaoSelected"
                        mlLabels
                        title="situacao"
                        clearable
                        @input="onSituacaoChanged"
                        :height="40"
                    />
                </div>

                <div class="column is-3" v-if="permissaoVincular">
                    <button
                        class="save-btn botao-acao"
                        type="button"
                        @click="showModalCadastro"
                    >
                        {{ $t("adicionar-desconto-qtde") }}
                    </button>
                </div>
            </div>

            <div class="registry-wrapper">
                <empty-table-message v-if="isEmpty" />
                <b-table
                    v-else
                    :data="produtoqtdepreco"
                    class="data-table"
                    @sort="sortTable"
                    backend-sorting
                >
                    <b-table-column
                        v-for="(f, i) in fields"
                        :key="i"
                        :field="f.key"
                        :label="f.key != 'excluir' ? $t(f.key) : ''"
                        :width="f.width"
                        :class="{
                            'excluir-field': f.key == 'excluir',
                        }"
                        :sortable="f.sortable"
                        :custom-sort="f.sortFn"
                        v-slot="props"
                    >
                        <div v-if="f.key == 'excluir'">
                            <b-button
                                v-if="
                                    permissao.update &&
                                    !produtoQtdePrecoIntegracao
                                "
                                class="action-button"
                                :type="
                                    props.row['situacao'] == 1
                                        ? 'is-danger'
                                        : 'is-success'
                                "
                                :icon-right="
                                    props.row['situacao'] == 1
                                        ? 'delete'
                                        : 'check'
                                "
                                @click="promptChangeSituacao(props.row)"
                                v-tippy 
                                :title="$t(
                                    props.row['situacao'] == 1
                                        ? 'desativar'
                                        : 'reativar'
                                )"
                            />
                        </div>
                        <div v-else-if="f.key == 'situacao'">
                            <b-tag
                                class="table-tag table-tag-full-width"
                                :type="
                                    props.row['situacao'] == 1
                                        ? 'is-success'
                                        : 'is-danger'
                                "
                                size="is-medium"
                            >
                                {{
                                    $t(
                                        props.row["situacao"] == 1
                                            ? "ativo"
                                            : "inativo"
                                    )
                                }}
                            </b-tag>
                        </div>
                        <div
                            v-else-if="
                                f.key == 'diferenca' || f.key == 'desc-max'
                            "
                        >
                            {{ props.row[f.key] | decimal(2) }} %
                        </div>
                        <div v-else-if="f.key == 'inicio' || f.key == 'fim'" class="nobreak">
                            {{ props.row[f.key] | decimal(3, false, 0) }}
                        </div>
                        <div v-else>
                            {{ props.row[f.key] }}
                        </div>
                    </b-table-column>
                </b-table>
                <PaginationViewer
                    class="mb-0"
                    :resetPagination="pagination.resetPagination"
                    :totalItems="pagination.totalRows"
                    :perPageOptions="pagination.perPageOptions"
                    :optionStarted="pagination.optionStarted"
                    @change="updatePagination"
                />
            </div>

            <!-- MODAL DE CADASTRO DE DESCONTO POR QUANTIDADE -->
            <b-modal :active.sync="showModalCadastroDesconto">
                <div>
                    <DescontoQuantidadeModal
                        :idCliente="$route.params.id"
                        @fecharModal="closeModalCadastro"
                    />
                </div>
            </b-modal>
        </div>
    </div>
</template>

<script>
// SERVICES E MODAIS
import ProdutoQtdePrecoService from "@/services/vendas/cliente/abas/ProdutoQtdePrecoService";
import DescontoQuantidadeModal from "@/components/vendas/cliente/modal/DescontoQuantidadeModal.vue";

// COMPONENTS
import ContainerLoader from "@/components/content/loader/ContainerLoader";

export default {
    components: {
        ContainerLoader,
        DescontoQuantidadeModal,
    },
    data() {
        return {
            produtoQtdePrecoIntegracao:
                this.$store.state.user.tabelasERPWebServer.includes(
                    "PRODUTOQTDEPRECO"
                ),
            produtoqtdepreco: [],
            fields: [
                { key: "produto", width: null, sortable: true, sortFn: null },
                {
                    key: "tabela-preco",
                    width: null,
                    sortable: true,
                    sortFn: null,
                },
                { key: "empresa", width: null, sortable: true, sortFn: null },
                { key: "inicio", width: null, sortable: false, sortFn: null },
                { key: "fim", width: null, sortable: false, sortFn: null },
                {
                    key: "diferenca",
                    width: null,
                    sortable: false,
                    sortFn: null,
                },
                { key: "desc-max", width: null, sortable: false, sortFn: null },
                { key: "situacao", width: 80, sortable: true, sortFn: null },
                { key: "excluir", width: 20, sortable: false, sortFn: null },
            ],
            service: new ProdutoQtdePrecoService(this.$http, this.$router),
            permissao: false,
            permissaoUsuario: false,
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },

            //Filtro de busca por Situação
            situacaoSelected: { id: 4, label: "todos" }, //filtro de situação padrão ao se abrir a tela
            situacaoSelect: [
                { id: 2, label: "todos" },
                { id: 1, label: "ativos" },
                { id: 0, label: "inativos" },
            ],

            isLoading: false,
            isEmpty: false,
            debouncedOnSearch: null,
            queryFilter: "",

            //Ordenação de elementos na tabela
            colunaOrdenacao: "produto", //coluna padrão para a ordenação de elementos
            order: "asc",

            isSaving: false,
            linhaParaUpdate: null, //recebe a linha que sofrerá o update
            showModalCadastroDesconto: false,
            permissaoVincular: false,

            isVenda: this.$route.meta.contexto == "vendas",
            isAgro: this.$route.meta.contexto == "agro",
        };
    },
    created() {
        this.pagination.perPage =
            this.pagination.perPageOptions[this.pagination.optionStarted];

        if (this.isVenda) {
            this.permissao = this.hasPermissionAccess(
                'vendas', 
                'clientes', 
                'ven-cliente-politica-comercial-desconto-qtde')
        }else if(this.isAgro){
            this.abrev = this.$route.meta.contexto.slice(0,4);
            this.permissao = this.hasPermissionAccess(
                'agro', 
                'clientes', 
                'agro-cliente-politica-comercial-desconto-qtde');
        }

        if (!this.permissao.read) {
            this.$router.push({
                name: "acesso-nao-permitido",
                params: { tela: "clientes" },
            });
        } else {
            this.carregarDados();
            this.debouncedOnSearch = this.debounce(this.onSearch, 500);

            this.permissaoVincular =
                this.permissao.create && !this.produtoQtdePrecoIntegracao;
        }
    },
    methods: {
        generateId(numberId) {
            return this.$route.name + "-desconto-qtde-" + numberId;
        },
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;

            this.isLoading = true;

            this.findAll(
                    this.colunaOrdenacao,
                    this.order,
                    currentPage - 1,
                    this.pagination.perPage,
                    this.situacaoSelected.id,
                    this.$route.params.id,
                    this.queryFilter
                )
                .then(this.mapItems)
                .then((value) => {
                    this.produtoqtdepreco = value;
                    this.isEmpty = this.produtoqtdepreco.length <= 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage("error", "msg-erro-load");
                    console.error("Erro ao carregar descontos por quantidade.");
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        findAll(column, order, page, limit, situacao, idcliente, ...params) {
            if (this.isVenda) {
                return this.service
                .findAllVendas(column, order, page, limit, situacao, idcliente, ...params);
            }else {
                return this.service
                .findAllAgro(column, order, page, limit, situacao, idcliente, ...params);
            }
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;

            return body.content.map((m) => {
                return {
                    idProdutoQtdePreco: m.idprodutoqtdepreco,
                    produto: m.produto.descricao,
                    "tabela-preco": m.tabpreco.descricao,
                    empresa: m.empresa.nome,
                    inicio: m.qtdeinicio,
                    fim: m.qtdefim,
                    diferenca: m.diferenca,
                    "desc-max": m.descmaximo,
                    situacao: m.situacao,
                };
            });
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        sortTable(field, order) {
            this.colunaOrdenacao = field;
            this.order = order;
            this.carregarDados();
        },
        onSituacaoChanged(val) {
            this.situacaoSelected = val
                ? this.situacaoSelect.filter((v) => v.id == val.id)[0]
                : this.situacaoSelect[0];

            this.carregarDados();
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        promptChangeSituacao(row) {
            this.linhaParaUpdate = row;
            let message = this.$t(
                    row.situacao == 1
                        ? "msg-confirmacao-desativacao-n"
                        : "msg-confirmacao-reativacao-n", 
                    { n: row["produto"] }
                );
            this.$root.confirm({
                message: message,
                onConfirm: this.updateSituacaoRegistro,
                onCancel: this.removePrompt,
            });
        },
        removePrompt() {
            this.linhaParaUpdate = null;
        },
        updateSituacaoRegistro() {
            let tempFailure =
                this.linhaParaUpdate.situacao == 1
                    ? "msg-erro-ao-desativar-desconto-qtde"
                    : "msg-erro-ao-reativar-desconto-qtde";

            let tempProdutoQtdePreco = {
                idprodutoqtdepreco: this.linhaParaUpdate.idProdutoQtdePreco, //valor enviado para backend precisa estar minusculo
                situacao: this.linhaParaUpdate.situacao == 1 ? 0 : 1, //envia para o backend o inverso da situação atual
            };

            this.isLoading = true;

            this.updateSituacao(tempProdutoQtdePreco)
                .then((r) => {
                    if (r.status == 200) {
                        let tempSuccess =
                            r.content.situacao == 1
                                ? "msg-sucesso-ao-reativar-desconto-qtde"
                                : "msg-sucesso-ao-desativar-desconto-qtde";
                        this.$root.showMessage("success", tempSuccess);
                        this.carregarDados(this.pagination.currentPage);
                    } else if (r.status == 500) {
                        this.$root.showMessage(
                            "error",
                            "Erro ao atualizar status."
                        );
                    }
                })
                .catch((e) => {
                    console.error("Erro ao atualizar status.", e);
                    this.$root.showMessage("error", tempFailure);
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.linhaParaUpdate = null;
                });
        },
        updateSituacao(produtoQtdePreco) {
            return this.service.updateSituacao(produtoQtdePreco);
        },
        redirect(name) {
            setTimeout(() => {
                this.$router.push(
                    {
                        name: name,
                        query: {
                            tela: "cliente-usuario",
                            "id-cliente": this.$route.params.id,
                        },
                    },
                    1000
                );
            });
        },
        showModalCadastro() {
            this.showModalCadastroDesconto = !this.showModalCadastroDesconto;
        },
        closeModalCadastro() {
            this.showModalCadastroDesconto = false;
            this.carregarDados();
        },
    },
};
</script>

<style>
    .nobreak{
        word-break: initial;
    }
</style>

<style lang="scss" scoped>
.aba-cliente {
    height: 100%;

    .botao-acao {
        margin-top: 24px;
        width: 100%;
        height: 40px;
    }

    @media (max-width: 760px) {
        .search-bar {
            padding-bottom: 0.4rem;
        }
        .botao-acao {
            margin-top: 0;
        }
    }
}
</style>